import { Location } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AssessmentHeader } from '../interfaces/assessment-header.interface';

@Component({
    selector: 'app-assessment-header',
    templateUrl: './assessment-header.component.html',
    styleUrl: './assessment-header.component.scss'
})
export class AssessmentHeaderComponent {
    @Input() assessmentHeader: AssessmentHeader;

    constructor(
        private location: Location
    ) { }

    goBack() {
        this.location.back();
    }
}
